import Ajax from '../util/ajax';
import { deviceDeleted } from '../features/devices/devicesSlice';
import { hideDialog } from '../reducers/app';
export function deleteTransmitter() {
    return (dispatch, getState) => {
        const { edit_transmitter_dialog } = getState();
        const id = edit_transmitter_dialog.id;
        if (id !== undefined) {
            const ajax = new Ajax(dispatch);
            const url = '/transmitter/' + id;
            ajax.del(url, undefined, () => {
                dispatch(deviceDeleted(id));
                dispatch(hideDialog());
            });
        }
    };
}
